import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit } from '../i18n/libelles';

const BASE = '/v1/attestations-digitales/commandes';

const unwrap = (res) => res?.data?.data;

const unwrapPaginated = (res) => {
  const d = res?.data?.data;
  const list = Array.isArray(d) ? d : (d?.content || []);
  return {
    items: list,
    totalElements: res?.data?.totalElements ?? d?.totalElements ?? list.length,
    currentPage: res?.data?.currentPage ?? d?.number ?? 0,
    totalPages: res?.data?.totalPages ?? d?.totalPages ?? 1,
  };
};

// ── Consultation ──────────────────────────────────────────────────────────────

export async function listerToutes(page = 0, size = 20) {
  return unwrapPaginated(await axiosInstance.get(BASE, { params: { page, size, sort: 'createdAt,desc' } }));
}

export async function listerParCompagnie(compagnieId, page = 0, size = 20) {
  return unwrapPaginated(
    await axiosInstance.get(`${BASE}/compagnie/${compagnieId}`, { params: { page, size } })
  );
}

export async function getSolde(compagnieId) {
  return unwrap(await axiosInstance.get(`${BASE}/compagnie/${compagnieId}/solde`));
}

// ── Actions BNCB ──────────────────────────────────────────────────────────────

/** SOUMISE → EN_ATTENTE_PAIEMENT (génère la facture TVA) */
export async function valider(commandeTrackingId) {
  return unwrap(await axiosInstance.patch(`${BASE}/${commandeTrackingId}/valider`));
}

/** SOUMISE → REJETEE */
export async function rejeter(commandeTrackingId, motif) {
  return unwrap(await axiosInstance.patch(`${BASE}/${commandeTrackingId}/rejeter`, null, { params: { motif } }));
}

/** EN_ATTENTE_PAIEMENT → CHEQUE_RECU */
export async function enregistrerPaiement(commandeTrackingId, payload) {
  return unwrap(await axiosInstance.post(`${BASE}/${commandeTrackingId}/paiement`, payload));
}

/** CHEQUE_RECU → PAYEE */
export async function confirmerPaiement(commandeTrackingId) {
  return unwrap(await axiosInstance.patch(`${BASE}/${commandeTrackingId}/confirmer-paiement`));
}

/** PAYEE → VALIDEE (quota activé) */
export async function activerQuota(commandeTrackingId) {
  return unwrap(await axiosInstance.patch(`${BASE}/${commandeTrackingId}/activer-quota`));
}

/** BROUILLON/SOUMISE → ANNULEE */
export async function annuler(commandeTrackingId) {
  return unwrap(await axiosInstance.patch(`${BASE}/${commandeTrackingId}/annuler`));
}

// ── PDF ───────────────────────────────────────────────────────────────────────

export async function telechargerProforma(commandeTrackingId) {
  const res = await axiosInstance.get(`${BASE}/${commandeTrackingId}/proforma`, { responseType: 'blob' });
  return res.data;
}

export async function telechargerFacture(commandeTrackingId) {
  const res = await axiosInstance.get(`${BASE}/${commandeTrackingId}/facture`, { responseType: 'blob' });
  return res.data;
}

// ── Constantes UI ─────────────────────────────────────────────────────────────

export const STATUTS_COMMANDE_DIGITALE = avecLibelleTraduit({
  BROUILLON:           { color: 'default' },
  SOUMISE:             { color: 'gold' },
  EN_ATTENTE_PAIEMENT: { color: 'orange' },
  CHEQUE_RECU:         { color: 'cyan' },
  PAYEE:               { color: 'blue' },
  VALIDEE:             { color: 'green' },
  LIVREE:              { color: 'geekblue' },
  REJETEE:             { color: 'red' },
  ECOULEE:             { color: 'default' },
  ANNULEE:             { color: 'volcano' },
  // héritage
  DEMANDE:             { color: 'gold' },
  FACTURE_EMISE:       { color: 'blue' },
  SOLDEE:              { color: 'geekblue' },
}, 'referentiels:statutsCommandeDigitale');
